import { render } from "./AttentionPlease.vue?vue&type=template&id=469ace38"
import script from "./AttentionPlease.vue?vue&type=script&setup=true&lang=js"
export * from "./AttentionPlease.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/static-pages/AttentionPlease.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "469ace38"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('469ace38', __exports__)) {
    api.reload('469ace38', __exports__)
  }
  
  module.hot.accept("./AttentionPlease.vue?vue&type=template&id=469ace38", () => {
    api.rerender('469ace38', render)
  })

}


export default __exports__